import { ArrowRight } from 'lucide-react'

export function Logo({compact=false}:{compact?:boolean}) {
  return <span className={`logo ${compact?'logo--compact':''}`} aria-label="rxrouting">
    <span className="logo__wordmark"><span>rx</span>routing</span>
    {!compact&&<ArrowRight className="logo__route" size={15}/>}
  </span>
}
